import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import InputSearch from "../../../components/InputSearch";
import Toolbar from "@mui/material/Toolbar";
import Chip from "@mui/material/Chip";
import IntlMessages from "../../../utils/IntlMessages";
import ListItem from "@mui/material/ListItem";
import { getIntlTranslation, getLabel } from "../../../utils/helper";
import { CircularProgress } from "@mui/material";
import SaveButton from "../../../components/buttons/SaveButton";
import AddSite from "../components/AddSite";
import { useNavigate } from "react-router-dom";
import { miRoot } from "../../../utils/defaultValues";
import { useDispatch } from "react-redux";
import { createSite, getAllSites } from "../api/maintainenceInspectionApi";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../../../authentication/authTokenService";

export function GradientCircularProgress() {
    return (
        <React.Fragment>
            <svg width={20} height={20}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="30%" stopColor="#244a9a" />
                        <stop offset="70%" stopColor="#d08f8e" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress style={{ 'svg circle': { stroke: 'url(#my_gradient)' }, width: 20, height: 20 }} />
        </React.Fragment>
    );
}

const MaintainenceInspectionSites = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch();

    const [openAddSite, setOpenAddSite] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    const [filterList, setFilterList] = useState([]);
    useEffect(() => {
        dispatch(getAllSites());
        getUser();
    }, [dispatch]);

    const sites = useSelector((state) => state.maintainenceInspection?.sites || []);
    useEffect(() => {
        setFilterList(sites);
    }, [sites]);

    useEffect(() => {
        getUser();
    }, [])

    const getUser = () => {
        const userData = getCurrentUser();
        setCurrentUser(userData.data);
    };

    const onSubmit = async (payload) => {
        await dispatch(createSite({ data: payload }));
        await dispatch(getAllSites());
        setOpenAddSite(false);
    }


    const renderProject = (p) => (
        <ListItem key={p.id} disablePadding>
            <Box
                sx={{
                    width: '100%',
                    p: 2,
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gridTemplateRows: 'auto auto',
                    columnGap: 3,
                    rowGap: 0.5,
                    alignItems: 'start',
                }}
            >
                <Box sx={{ gridColumn: '1 / 2', gridRow: '1 / 3', minWidth: 0 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#254a9a' }}>
                        {p.name}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.7 }}>
                        {`${p.street}, ${p.postalCode}, ${p.city}`}
                    </Typography>
                </Box>
                <Box sx={{ gridColumn: '2 / 3', gridRow: '1 / 2', justifySelf: 'end' }}>
                    <SaveButton
                        id="view-report"
                        buttonText="mi.view"
                        variant="button"
                        size="small"
                        style={{
                            padding: '4px 14px',
                            fontSize: '0.8rem',
                            minWidth: 'auto',
                            lineHeight: 1.25,
                        }}
                        tooltip={{ title: getIntlTranslation('tooltip.view-site') }}
                        handleClick={(e) => {
                            navigate(`${miRoot}/site-overview/${p.id}`, { state: { site: p } });
                        }}
                    />
                </Box>
            </Box>
        </ListItem>
    );


    return (
        <>
            <Box className="w-100 h-100 d-flex align-items-center justify-content-center">
                <Card style={{ width: "60%" }} className="h-100 m-1 rounded-3">
                    <Toolbar style={{ height: 40 }}>
                        <Typography
                            variant="h6"
                            noWrap
                            component="div"
                            sx={{
                                flexGrow: 1,
                                display: { xs: "none", sm: "block", width: "40%" },
                            }}
                        >
                            <IntlMessages id="mi.sites" />
                        </Typography>
                        <Box
                            style={{ width: "100%" }}
                            className="d-flex align-items-center justify-content-start p-1 m-1 rounded-3"
                        >
                            <InputSearch />
                        </Box>
                    </Toolbar>
                    <CardContent
                        style={{ height: "calc(100% - 40px)", overflowY: "auto" }}
                        className="p-1"
                    >
                        <List
                            style={{
                                width: "100%",
                                bgcolor: "background.paper",
                                height: "100%",
                                overflow: "auto",
                                scrollBehavior: "smooth",
                            }}
                            className="custom-scrollBar"
                        >
                            {filterList.length === 0 ? (
                                <IntlMessages id="_no records" />
                            ) : (
                                filterList
                                    .filter((f) => f.favoriteProject)
                                    .map((p) => renderProject(p))
                            )}
                            <Divider>
                                <Chip label={getLabel("mi.my-sites")} />
                            </Divider>
                            {filterList
                                .filter((f) => !f.favoriteProject)
                                .map((p) => renderProject(p))}
                        </List>
                        {currentUser && currentUser.roles && (currentUser.roles.includes("ADMIN") || currentUser.roles.includes("PROJECT LEADER") )? (
                            <Box
                                sx={{
                                    position: "absolute",
                                    right: 320,
                                    bottom: 50,
                                }}
                            >
                                <SaveButton
                                    id="add-report-button"
                                    buttonText="mi.add-site"
                                    variant="button"
                                    size="medium"
                                    style={{
                                        padding: "8px 16px",
                                        fontSize: "0.9rem",
                                        minWidth: "auto",
                                        lineHeight: 1.25,
                                    }}
                                    tooltip={{ title: '' }}
                                    handleClick={(e) => {
                                        setOpenAddSite(true)
                                    }}
                                />
                            </Box>) : null}
                    </CardContent>
                </Card>
                {openAddSite ? <AddSite
                    open={openAddSite}
                    onClose={() => setOpenAddSite(false)}
                    onSubmit={(payload) => {
                        onSubmit(payload);
                    }}
                    currentUser={currentUser}
                /> : null}
            </Box>
        </>
    );
};

export default MaintainenceInspectionSites;